module.exports = __webpack_public_path__ + "img/fluid-wagon-shadow-2.b7d9c806.png";